import React, { useEffect, useState } from 'react'
import { useDebounce } from '../../src/hooks/useDebounce'
import { useTranslate } from '../../src/hooks/useTranslate'
import { Input } from '../Input'

export const HelpSearchBox: React.FC<{ currentQuery: string | null, onSearch: (query: string) => void }> = ({
	currentQuery,
	onSearch,
}) => {
	const [query, setQuery] = useState(currentQuery || '')
	const debouncedQuery = useDebounce(query, 200)
	const translate = useTranslate();

	useEffect(() => {
		if(debouncedQuery != (currentQuery ?? ''))
		{
			onSearch(debouncedQuery);
		}
	}, [debouncedQuery])


	return (
		<div style={{ maxWidth: '230px' }}>
			<Input
				value={query}
				name="query-small-bland"
				label={translate('search') + ':'}
				submitStyle="bland"
				onChange={(e) => {
					setQuery(e.currentTarget.value)
				}}
				micro
				autoFocus={currentQuery ? true : false}
			/>
		</div>
	)
}
